import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-2.5 text-sm" }
const _hoisted_2 = ["id", "name", "onChange", "checked"]
const _hoisted_3 = ["for"]


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioGroup',
  props: {
    modelValue: {
        default: null,
        required: true,
    },
    options: {
        type: Array,
    },
    name: {
        type: String,
    },
    label: {
        type: String,
    },
    keyID: {
        type: String,
        default: 'key',
    },
    error: {
        type: String,
        default: null,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(["text-[10px] mt-1", __props.error ? 'text-red-600' : 'text-gray-800']),
          id: "email-error"
        }, _toDisplayString(__props.error), 3))
      : _createCommentVNode("", true),
    _createElementVNode("p", _hoisted_1, _toDisplayString(__props.label), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "flex items-center mb-2.5 last:mb-0"
      }, [
        _createElementVNode("input", {
          id: `${__props.keyID}-${option.id}`,
          name: __props.name,
          type: "radio",
          class: "cursor-pointer h-4 w-4 text-black border-gray-300 focus:ring-0 focus:ring-offset-0 focus:outline-0 focus:outline-offset-0 checked:border-black",
          onChange: ($event: any) => (_ctx.$emit('update:modelValue', option.value)),
          checked: __props.modelValue === option.value
        }, null, 40, _hoisted_2),
        _createElementVNode("label", {
          for: option.id,
          class: _normalizeClass(["ml-3 block text-sm", __props.modelValue === option.value ? 'text-primary-600' : 'text-black'])
        }, _toDisplayString(option.label), 11, _hoisted_3)
      ]))
    }), 128))
  ], 64))
}
}

})